export const REQUEST_FOLLOW_UP_REASONS = "REQUEST_FOLLOW_UP_REASONS";
export const REQUEST_FOLLOW_UP_REASONS_SUCCEEDED = "REQUEST_FOLLOW_UP_REASONS_SUCCEEDED";
export const REQUEST_FOLLOW_UP_REASONS_FAILED = "REQUEST_BILLING_ACTIVITIES_FAILED";
export const SAVE_FOLLOW_UPS_INFO = "SAVE_FOLLOW_UPS_INFO";
export const SAVE_FOLLOW_UPS_INFO_SUCCEEDED = "SAVE_FOLLOW_UPS_INFO_SUCCEEDED";
export const UPDATE_FOLLOW_UPS_INFO_SUCCEEDED = "UPDATE_FOLLOW_UPS_INFO_SUCCEEDED";
export const UPDATE_FOLLOW_UPS_INFO_FAILED = "UPDATE_FOLLOW_UPS_INFO_FAILED";
export const SAVE_FOLLOW_UPS_INFO_FAILED = "SAVE_FOLLOW_UPS_INFO_FAILED";
export const RESET_FOLLOW_UPS_STATE = "RESET_FOLLOW_UPS_STATE";
export const REQUEST_FOLLOW_UP_DUE_DATE = "REQUEST_FOLLOW_UP_DUE_DATE";
export const FOLLOW_UP_DUE_DATE_SUCCEEDED = "FOLLOW_UP_DUE_DATE_SUCCEEDED";
export const DUPLICATE_CHECK_POPUP = "DUPLICATE_CHECK_POPUP";
export const DUPLICATE_WORKORDERS = "DUPLICATE_WORKORDERS";
export const CLEAR_DUPLICATE_WORKORDERS = "CLEAR_DUPLICATE_WORKORDERS";
export const SET_DUPLICATE_WORKORDERS = "SET_DUPLICATE_WORKORDERS";
export const NO_DUPLICATES_CHECK = "NO_DUPLICATES_CHECK";

export const requestFollowUpReasons = () => {
    return {
        type: REQUEST_FOLLOW_UP_REASONS,
    };
};

export const clearDuplicateWorkOrders = () => {
    return {
        type: CLEAR_DUPLICATE_WORKORDERS,
    };
};
export const setDuplicateWorkOrders = (payload) => {
    return {
        type: SET_DUPLICATE_WORKORDERS,
        payload,
    };
};
export const duplicateCheckPopup = (payload) => {
    return {
        type: DUPLICATE_CHECK_POPUP,
        payload,
    };
};

export const noDuplicatesCheck = (payload) => {
    return {
        type: NO_DUPLICATES_CHECK,
        payload,
    };
};

export const duplicateWorkOrders = (payload) => {
    return {
        type: DUPLICATE_WORKORDERS,
        payload,
    };
};

export const getFollowUpDewDateSucceeded = (data, index) => {
    return {
        type: FOLLOW_UP_DUE_DATE_SUCCEEDED,
        dueDate: data.body,
        index: index,
    };
};

export const requestFollowUpDueDate = (workorderNumber) => {
    return {
        type: REQUEST_FOLLOW_UP_DUE_DATE,
        workorderNumber,
    };
};

export const requestFollowUpReasonsSucceeded = (followUpReasons) => {
    return {
        type: REQUEST_FOLLOW_UP_REASONS_SUCCEEDED,
        followUpReasons,
    };
};

export const requestFollowUpReasonsFailed = (message) => {
    return {
        type: REQUEST_FOLLOW_UP_REASONS_FAILED,
        message,
    };
};

export const saveFollowUps = (followUpsRequest, workOrderNumber, refresh, payload) => {
    return {
        type: SAVE_FOLLOW_UPS_INFO,
        followUpsRequest,
        workOrderNumber,
        refresh,
        payload,
    };
};

export const saveFollowUpsSucceeded = (followUpsResponse) => {
    return {
        type: SAVE_FOLLOW_UPS_INFO_SUCCEEDED,
        followUpsResponse,
    };
};
export const updateFollowUpResponse = (followUpsResponse) => {
    return {
        type: UPDATE_FOLLOW_UPS_INFO_SUCCEEDED,
        followUpsResponse,
    };
};
export const updateFollowUpResponseFailed = (followUpsResponse) => {
    return {
        type: UPDATE_FOLLOW_UPS_INFO_FAILED,
        followUpsResponse,
    };
};

export const saveFollowUpsFailed = (message) => {
    return {
        type: SAVE_FOLLOW_UPS_INFO_FAILED,
        message,
    };
};

export const resetFollowUpsState = () => {
    return {
        type: RESET_FOLLOW_UPS_STATE,
    };
};
